import { useEffect, useState } from 'react';
import styles from 'styles/modules/popUps/Uploader.module.scss';
import { addFile } from 'store/company';
import { useDispatch } from 'react-redux';

export default function UploaderProgress({
    file,
    settings,
    onSuccess,
    onError,
}) {
    const dispatch = useDispatch();
    const [prc, setPrc] = useState(0);

    useEffect(() => {
        async function uploadFile() {
            const formData = new FormData();
            formData.append(settings.title, file);
            await dispatch(
                addFile(formData, (val) => {
                    setPrc(val);
                })
            );
        }

        uploadFile().then((res) => {
            onSuccess();
        });
    }, [file]);

    return (
        <div>
            <div className={styles.progressBar}>
                <div
                    className={styles.progressBarFill}
                    style={{ width: `${prc}%` }}
                />
            </div>
        </div>
    );
}
